const wholeTeamGetter = () => [window.DataModel.owner, ...window.DataModel.TeamsService.subTeamUsers];

export default wholeTeamGetter;
